import { render } from "./Visit.vue?vue&type=template&id=79cef8e0"
import script from "./Visit.vue?vue&type=script&lang=js"
export * from "./Visit.vue?vue&type=script&lang=js"
script.render = render

export default script